import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, switchMap } from 'rxjs';
import { errMessage } from '@ui';
import { UserActivityLogActions } from '../state/user-activity-log/user-activity-log.actions';
import { UserActivityLogService } from '../../services/user-activity-log.service';
import { SharedActions } from '../state/shared/shared.actions';

export const startLoadingUserActivityLog$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(UserActivityLogActions.startLoadingUserActivityLog),
      exhaustMap(({ filters }) => [
        UserActivityLogActions.setIsLoading({ isLoading: true }),
        UserActivityLogActions.loadUserActivityLog({ filters }),
      ]),
    ),
  { functional: true },
);

export const loadUserActivityLog$ = createEffect(
  (actions$ = inject(Actions), service = inject(UserActivityLogService)) =>
    actions$.pipe(
      ofType(UserActivityLogActions.loadUserActivityLog),
      switchMap(({ filters }) =>
        service.getAll(filters).pipe(
          switchMap((items) => [
            UserActivityLogActions.loadUserActivityLogSuccess({ items }),
            UserActivityLogActions.setIsLoading({ isLoading: false }),
          ]),
          catchError((response) => [
            UserActivityLogActions.loadUserActivityLogFail(),
            UserActivityLogActions.setIsLoading({ isLoading: false }),
            SharedActions.showMessage({ error: errMessage(response) }),
          ]),
        ),
      ),
    ),
  { functional: true },
);
